import { API_BASE } from "./backendUrls";
import contractRoutes from './form-contracts/routes.json';
// Contracts are lazy-loaded so viewing pages does not load validation for every module.
let contractsPromise;
export function findFormContract(contracts, method, url) {
  const path = String(url).split('?')[0].replace(/\/$/, '') || '/';
  const parts = path.split('/');
  return contracts.find(contract => contract.method === method.toUpperCase() && contract.path.split('/').length === parts.length && contract.path.split('/').every((part,index) => part.startsWith(':') ? Boolean(parts[index]) : part === parts[index]));
}
export function formBody(body) {
  if (typeof FormData !== 'undefined' && body instanceof FormData) {
    const data = {};
    for (const [key,value] of body.entries()) {
      // Multer puts files in req.file/req.files rather than req.body.
      if (typeof value !== 'string') continue;
      if (Object.prototype.hasOwnProperty.call(data,key)) data[key] = [].concat(data[key],value);
      else data[key] = value;
    }
    return data;
  }
  return typeof body === 'string' ? JSON.parse(body) : body;
}
export function normalizeOptionalFormFields(contract, data) {
  if (!data || typeof data !== 'object' || Array.isArray(data) || !contract.schema.shape) return data;
  const normalized = {...data};
  for (const [key,field] of Object.entries(contract.schema.shape)) {
    if (data[key] !== '' || field.safeParse('').success) continue;
    let base = field;
    for (let depth=0; depth<10; depth++) {
      const inner = base._def?.innerType || base._def?.out || base._def?.schema;
      if (!inner) break;
      base = inner;
    }
    const type = base._def?.type || base._def?.typeName;
    const isDate = type === 'date' || type === 'ZodDate';
    const isUuid = (base._def?.checks || []).some(check => check._zod?.def?.format === 'uuid' || check.kind === 'uuid');
    if (!isDate && !isUuid) continue;
    const nullable = field.safeParse(null);
    if (nullable.success && nullable.data === null) normalized[key] = null;
    else if (contract.method === 'POST' && field.safeParse(undefined).success) delete normalized[key];
  }
  return normalized;
}
export function checkFormContract(contract, body) {
  if (!contract) return body;
  const multipart = typeof FormData !== "undefined" && body instanceof FormData;
  const data = multipart ? formBody(body) : normalizeOptionalFormFields(contract, formBody(body));
  const result = contract.schema.safeParse(data);
  if (result.success) return multipart ? body : typeof body === "string" ? JSON.stringify(data) : data;
  const fieldErrors = {};
  for (const issue of result.error.issues) {
    const path = issue.path.join('.') || 'form';
    (fieldErrors[path] ||= []).push(issue.message);
  }
  const readable = key => key.replace(/([a-z])([A-Z])/g,'$1 $2').replace(/Id\b/g,'').replace(/_/g,' ').trim();
  const error = new Error('Please correct the following fields: ' + Object.entries(fieldErrors).map(([key,messages]) => readable(key) + ': ' + messages.join(', ')).join('; '));
  error.name = 'FormValidationError';
  error.code = 'FORM_VALIDATION';
  error.status = 400;
  error.errors = {fieldErrors, formErrors: []};
  throw error;
}
export async function validateFormRequest(method, url, body) {
  if (!['POST','PUT','PATCH'].includes(method.toUpperCase())) return body;
  if (!findFormContract(contractRoutes,method,url)) return body;
  contractsPromise ||= import('./form-contracts').then(module => module.formContracts);
  const contracts = await contractsPromise;
  return checkFormContract(findFormContract(contracts,method,url),body);
}

export async function formFetch(input, options = {}) {
  const apiBase = API_BASE;
  const target = new URL(String(input), apiBase);
  const body = target.origin === new URL(apiBase).origin ? await validateFormRequest(options.method || 'GET', target.pathname, options.body) : options.body;
  return fetch(input, {...options, ...(Object.prototype.hasOwnProperty.call(options,'body') ? {body} : {})});
}
export function assertFiniteFormNumbers(value, path = []) {
  if (typeof value === 'number' && !Number.isFinite(value)) {
    const error = new Error('Enter a finite number for ' + (path.join('.') || 'amount') + '.');
    error.name = 'FormValidationError'; error.code = 'FORM_VALIDATION'; error.status = 400;
    error.errors = {fieldErrors: {[path.join('.') || 'form']: [error.message]}, formErrors: []};
    throw error;
  }
  if (value && typeof value === 'object' && !(value instanceof Date) && !(typeof FormData !== 'undefined' && value instanceof FormData)) for (const [key,item] of Object.entries(value)) assertFiniteFormNumbers(item,[...path,key]);
}

